import { useKnockFeed as w, useTranslations as T, renderNodeOrFallback as _, formatTimestamp as h } from "@knocklabs/react-core";
import n, { useMemo as A } from "react";
import { Button as B } from "../../../core/components/Button/Button.mjs";
import { ButtonGroup as H } from "../../../core/components/Button/ButtonGroup.mjs";
import "lodash.debounce";
import { ArchiveButton as M } from "./ArchiveButton.mjs";
import { Avatar as x } from "./Avatar.mjs";

function p(e) {
  e && e !== "" && setTimeout(() => window.location.assign(e), 200);
}
const L = n.forwardRef(({
  item: e,
  onItemClick: l,
  onButtonClick: i,
  avatar: E,
  children: m,
  archiveButton: N
}, b) => {
  var u;
  const {
    feedClient: o,
    colorMode: k
  } = w(), {
    locale: v
  } = T(), c = A(() => e.blocks.reduce((t, a) => ({
    ...t,
    [a.name]: a
  }), {}), [e]), f = (u = c.action_url) == null ? void 0 : u.rendered, d = c.actions, s = n.useCallback(() => (o.markAsInteracted(e), l ? l(e) : p(f)), [e, f, l, o]), y = n.useCallback((t, a) => (o.markAsInteracted(e), i ? i(e, a) : p(a.action)), [i, o, e]), C = n.useCallback((t) => {
    switch (t.key) {
      case "Enter": {
        t.stopPropagation(), s();
        break;
      }
    }
  }, [s]), r = e.actors[0];
  return /* @__PURE__ */ n.createElement("div", { ref: b, className: `rnf-notification-cell rnf-notification-cell--${k}`, onClick: s, onKeyDown: C, tabIndex: 0 }, /* @__PURE__ */ n.createElement("div", { className: "rnf-notification-cell__inner" }, !e.read_at && /* @__PURE__ */ n.createElement("div", { className: "rnf-notification-cell__unread-dot" }), _(E, r && "name" in r && r.name && /* @__PURE__ */ n.createElement(x, { name: r.name, src: r.avatar })), /* @__PURE__ */ n.createElement("div", { className: "rnf-notification-cell__content-outer" }, c.body && /* @__PURE__ */ n.createElement("div", { className: "rnf-notification-cell__content", dangerouslySetInnerHTML: {
    __html: c.body.rendered
  } }), d && /* @__PURE__ */ n.createElement("div", { className: "rnf-notification-cell__button-group" }, /* @__PURE__ */ n.createElement(H, null, d.buttons.map((t, a) => /* @__PURE__ */ n.createElement(B, { variant: a === 0 ? "primary" : "secondary", key: t.name, onClick: (g) => y(g, t) }, t.label)))), m && /* @__PURE__ */ n.createElement("div", { className: "rnf-notification-cell__child-content" }, m), /* @__PURE__ */ n.createElement("span", { className: "rnf-notification-cell__timestamp" }, h(e.inserted_at, {
    locale: v
  }))), _(N, /* @__PURE__ */ n.createElement(M, { item: e }))));
});
export {
  L as NotificationCell
};
//# sourceMappingURL=NotificationCell.mjs.map
